import { PropsWithChildren, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore } from "@/state/authStore";

export function ProtectedRoute({ children }: PropsWithChildren) {
  const location = useLocation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const loading = useAuthStore((state) => state.loading);
  const bootstrapSession = useAuthStore((state) => state.bootstrapSession);
  const forceLogout = useAuthStore((state) => state.forceLogout);

  useEffect(() => {
    if (!isAuthenticated) {
      void bootstrapSession();
    }
  }, [bootstrapSession, isAuthenticated]);

  useEffect(() => {
    const handler = () => forceLogout();
    window.addEventListener("linkflow:session-expired", handler);
    return () => window.removeEventListener("linkflow:session-expired", handler);
  }, [forceLogout]);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center bg-ink-900 text-sm text-ink-300">
        Validando sessão...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
